export default {"src":"/kelp/_next/static/media/stETH.1b1d4104.svg","height":45,"width":45,"blurWidth":0,"blurHeight":0};